import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import { BOOKS_FOR_PAGE, API_URL } from '@/helpers/variables';
import SeriesDetail from '@/components/screens/series-detail/SeriesDetail';
import { ISeriesBooksPage } from '@/interfaces/seriesBooksPage.interface';

interface ISeriesPageDynamicProps {
  books: ISeriesBooksPage;
}

const SeriesPageDynamic: NextPage<ISeriesPageDynamicProps> = ({ books }) => {
  return <SeriesDetail books={books} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { id } = context.query;

  const res = await fetch(`${API_URL}series/?id=${id}&status=active&page=1&page_size=${BOOKS_FOR_PAGE}&book_page=1&book_page_size=${BOOKS_FOR_PAGE}`);

  // Check fetch error
  if (!res.ok) {
    console.table(`Error ${res.status}. Api: ${res.url}`);
    return {
      notFound: true,
    };
  }

  const books = await res.json();

  return {
    props: { books },
  };
};

export default SeriesPageDynamic;
